import { types } from 'mobx-state-tree'
import Expression from '../Expression'
import RawText from '../RawText'
import TextOption from '../TextOption'
import { Fill } from './shared/props'
import { Layerable } from './shared/props'
import { Rectangle } from './shared/props'
import { Stroke } from './shared/props'
import { Transformable } from './shared/props'
import { Visible } from './shared/props'
import { Typography } from './shared/props'
import { UI } from './shared/props'
import assetChildTypes from './shared/childTypes'
import assetViews from './shared/views'

const AssetType = 'RadioGroupInput'

const state = types.model({
  ...Layerable,
  ...Fill,
  ...Stroke,
  ...Rectangle,
  ...Typography,
})

const states = types.model({
  active: types.compose(state),
  disabled: types.compose(state),
  hover: types.compose(state),
})

const model = types
  .model(AssetType, {
    // Entity
    Type: types.literal(AssetType),
    objectId: types.identifier,
    // Asset
    name: types.string,
    children: types.late(assetChildTypes),
    value: Expression,
    disabled: Expression,
    text: RawText,
    textOptions: types.array(TextOption),
    template: types.null,
    states,
    ...Layerable,
    ...Fill,
    ...Stroke,
    ...Rectangle,
    ...Visible,
    ...Transformable,
    ...Typography,
    ...UI,
  })
  .views(assetViews)

export default model
